/** @file quadColorOf: a drawable's stable quad colour index (FNV-1a hash of its id into `QUAD_PALETTE`). */
import { QUAD_PALETTE } from './quadPalette';

/** The same index for the same id on every frame and every load; ids differing in one character usually differ. */
export function quadColorOf(id: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < id.length; i++) h = Math.imul(h ^ id.charCodeAt(i), 0x01000193) >>> 0;
  return h % QUAD_PALETTE.length;
}
